"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var shallowequal = require("shallowequal");
var Text_st_css_1 = require("./Text.st.css");
var utils_1 = require("../utils");
var loadable_1 = require("../../components/loadable");
var debounce = require('lodash/debounce');
var LoadableTooltip = /** @class */ (function (_super) {
    tslib_1.__extends(LoadableTooltip, _super);
    function LoadableTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LoadableTooltip;
}(loadable_1.Loadable));
var StateFullComponentWrap = /** @class */ (function (_super) {
    tslib_1.__extends(StateFullComponentWrap, _super);
    function StateFullComponentWrap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StateFullComponentWrap.prototype.render = function () {
        var _a = this.props, children = _a.children, props = tslib_1.__rest(_a, ["children"]);
        return React.cloneElement(children, props);
    };
    return StateFullComponentWrap;
}(React.Component));
var EllipsedTooltip = /** @class */ (function (_super) {
    tslib_1.__extends(EllipsedTooltip, _super);
    function EllipsedTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isEllipsisActive: false };
        _this._updateEllipsisState = function () {
            var isEllipsisActive = _this.props.showTooltip &&
                _this.textNode &&
                _this.textNode.offsetWidth < _this.textNode.scrollWidth;
            _this.setState({
                isEllipsisActive: isEllipsisActive,
            });
        };
        _this._debouncedUpdate = debounce(_this._updateEllipsisState, 100);
        return _this;
    }
    EllipsedTooltip.prototype.componentDidMount = function () {
        window.addEventListener('resize', this._debouncedUpdate);
        this._updateEllipsisState();
    };
    EllipsedTooltip.prototype.componentWillUnmount = function () {
        this._debouncedUpdate.cancel();
        window.removeEventListener('resize', this._debouncedUpdate);
    };
    EllipsedTooltip.prototype.componentDidUpdate = function (prevProps) {
        // if props changed, then we want to re-check node for ellipsis state
        // and we can not do such check in render, because we want to check already rendered node
        if (!shallowequal(prevProps, this.props)) {
            this._updateEllipsisState();
        }
    };
    EllipsedTooltip.prototype._renderText = function () {
        var _this = this;
        var _a = this.props, component = _a.component, style = _a.style;
        return (React.createElement(StateFullComponentWrap, tslib_1.__assign({}, Text_st_css_1.default('root', {}, component.props), { style: tslib_1.__assign({}, style, { whiteSpace: 'nowrap' }), ref: function (n) { return (_this.textNode = ReactDOM.findDOMNode(n)); } }), component));
    };
    EllipsedTooltip.prototype.render = function () {
        var _this = this;
        var _a = this.props, shouldLoadAsync = _a.shouldLoadAsync, showTooltip = _a.showTooltip, tooltipProps = _a.tooltipProps;
        var isEllipsisActive = this.state.isEllipsisActive;
        var shouldLoadTooltip = isEllipsisActive && showTooltip;
        return (React.createElement(LoadableTooltip, { loader: {
                Tooltip: function () {
                    return shouldLoadAsync
                        ? Promise.resolve().then(function () { return require('../../components/tooltip'); }) : require('../../components/tooltip');
                },
                tooltipStyle: function () {
                    return shouldLoadAsync
                        ? Promise.resolve().then(function () { return require('./EllipsedTooltip.st.css'); }) : require('./EllipsedTooltip.st.css');
                },
            }, defaultComponent: this._renderText(), namedExports: {
                Tooltip: 'Tooltip',
            }, shouldLoadComponent: shouldLoadTooltip }, function (_a) {
            var Tooltip = _a.Tooltip, tooltipStyle = _a.tooltipStyle;
            return (React.createElement(Tooltip, tslib_1.__assign({ appendTo: "scrollParent" }, tooltipProps, tooltipStyle('root', {}, tooltipProps || _this.props), { content: React.createElement("div", null, _this.textNode.textContent), showArrow: true }), _this._renderText()));
        }));
    };
    EllipsedTooltip.defaultProps = { showTooltip: true };
    return EllipsedTooltip;
}(React.Component));
exports.withEllipsedTooltip = function (_a) {
    var _b = _a === void 0 ? {} : _a, showTooltip = _b.showTooltip, shouldLoadAsync = _b.shouldLoadAsync, tooltipProps = _b.tooltipProps;
    return function (Comp) {
        var WrapperComponent = function (props) { return (React.createElement(EllipsedTooltip, tslib_1.__assign({}, props, { component: React.createElement(Comp, props), shouldLoadAsync: shouldLoadAsync, showTooltip: showTooltip, "data-hook": "ellipsed-tooltip-wrapper", tooltipProps: tooltipProps }))); };
        WrapperComponent.displayName = utils_1.getDisplayName(Comp);
        return WrapperComponent;
    };
};
//# sourceMappingURL=withEllipsedTooltip.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/hocs/EllipsedTooltip/withEllipsedTooltip.js
// module id = 1243
// module chunks = 0